/*
 * @Author: yunxiaodong
 * @Date: 2023-11-03 17:49:04
 * @LastEditTime: 2023-11-06 09:15:57
 * @LastEditors: your name
 * @Description:
 * @FilePath: \boe-srm-frame-frontend\src\main.js
 * 可以输入预定的版权声明、个性签名、空行等
 */
/**
 * @name 统一注册外部插件、样式、服务等
 */
import "./core/install";
import { vueRender } from "./core/render";
vueRender({}, true);
/**
 * @name 验证登陆身份并启动微应用
 */
import microAppStart from "./core/auth";
microAppStart();
